import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Table, Layout, Breadcrumb, Row, Col, DatePicker, Select, Button, Skeleton, Divider, Spin } from "antd";
import ReactToPrint from "react-to-print";
import { getDispatchReport } from "../../../actions/report";
import { getAllLocationPlain } from "../../../actions/warehouseAction";
import { getdeliverytype } from "../../../actions/settings";
import Excelldownload from "./Excelldownload";
import moment from "moment";
import dateFormat from "dateformat";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const DispatchReport = ({ getDispatchReport, getAllLocationPlain, getdeliverytype, Auth, businessprofile }) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const [data, setData] = useState({ results: [], count: 0 });
  const [loading, setLoading] = useState(true);
  const [outletlist, setOutletlist] = useState([]);
  const [courierlist, setCourierlist] = useState([]);
  const [reload, setReload] = useState(false);
  
  const componentRef = useRef();
  const start = useRef("");
  const end = useRef("");
  const location = useRef("");
  const courier = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(100);
  console.log(data)

  useEffect(() => {
    getAllLocationPlain().then((result) => setOutletlist(result));
    getdeliverytype().then((result) => setCourierlist(result));
  }, []);

  useEffect(() => {
    setLoading(true);
    getDispatchReport(start.current, end.current, location.current, pageno.current, page_size.current, courier.current)
      .then((result) => {
        if (result) {
          setData(result);
        }
        setLoading(false);
      });
  }, [reload]);

  const columns = [
    {
      title: "SL",
      key: "index",
      render: (text, record, index) => (pageno.current - 1) * page_size.current + index + 1
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_number",
      key: "invoice_number"
    },
    {
      title: "Dispatch Date",
      dataIndex: "dispatch_date",
      key: "dispatch_date",
      render: (date) => date ? dateFormat(date, "mmm d, yyyy") : "-"
    },
    {
      title: "Location",
      dataIndex: "location_name",
      key: "location_name"
    },
    {
      title: "Courier",
      dataIndex: "delivery_type_name",
      key: "delivery_type_name"
    },
    {
      title: "Customer",
      dataIndex: "contact_name",
      key: "contact_name"
    },
    {
      title: "Phone",
      dataIndex: "contact_phone",
      key: "contact_phone"
    },
    {
      title: "Account No",
      dataIndex: "Account_no",
      key: "Account_no",
      render: (val) => val || "N/A"
    },
    {
      title: "Transaction No",
      dataIndex: "Transection_no",
      key: "Transection_no",
      render: (val) => val || "N/A"
    },
    {
      title: "Payment",
      dataIndex: "payment",
      key: "payment",
      render: (val) => formatter.format(val)
    },
    {
      title: "Due",
      dataIndex: "due",
      key: "due",
      render: (val) => formatter.format(val)
    },
    {
      title: "Dispatched By",
      dataIndex: "dispatched_by",
      key: "dispatched_by",
      // render: (val) => formatter.format(val)
    },
  ];

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Dispatch Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame" style={{ padding: "20px" }}>
        <Row gutter={16} align="bottom">
          <Col span={6}>
            <h5 style={{fontWeight:"600"}}>Dispatch Date Range:</h5>
            <RangePicker
              style={{ width: "100%" }}
              onChange={(value) => {
                if (value) {
                  start.current = value[0].format("YYYY-MM-DD");
                  end.current = value[1].format("YYYY-MM-DD");
                } else {
                  start.current = "";
                  end.current = "";
                }
              }}
            />
          </Col>
          <Col span={5}>
            <h5 style={{fontWeight:"600"}}>Outlet:</h5>
            <Select
              placeholder="Select Outlet"
              style={{ width: "100%" }}
              onChange={(val) => location.current = val || ""}
              allowClear
            >
              <Option value="">All Outlets</Option>
              {outletlist.map(o => <Option key={o.id} value={o.id}>{o.name}</Option>)}
            </Select>
          </Col>
          <Col span={5}>
            <h5 style={{fontWeight:"600"}}>Courier:</h5>
            <Select
              placeholder="Select Courier"
              style={{ width: "100%" }}
              onChange={(val) => courier.current = val || ""}
              allowClear
            >
              <Option value="">All Couriers</Option>
              {courierlist.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
            </Select>
          </Col>
          <Col span={2}>
            <Button 
              type="primary" 
              onClick={() => { 
                pageno.current = 1; 
                setReload(!reload); 
              }}
              style={{width: "100%"}}
            >
              Search
            </Button>
          </Col>
          <Col span={3}>
            <Excelldownload data={data.results} />
          </Col>
          <Col span={3}>
            <ReactToPrint
              trigger={() => <Button type="primary" style={{ width: "100%", backgroundColor: "#1890ff" }}>Print PDF</Button>}
              content={() => componentRef.current}
            />
          </Col>
        </Row>
        <Divider />
        <Spin spinning={loading}>
          {loading && data.results.length === 0 ? (
             <Skeleton active />
          ) : (
            <Table
              columns={columns}
              dataSource={data.results}
              rowKey="id"
              size="small"
              bordered
              pagination={{
                total: data.count,
                pageSize: page_size.current,
                current: pageno.current,
                showSizeChanger: false,
                onChange: (page) => { 
                  pageno.current = page; 
                  setReload(!reload); 
                }
              }}
              summary={() => (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={9} align="right">
                      <span style={{ fontWeight: "bold" }}>Total</span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={9}>
                      {/* <span style={{ fontWeight: "bold" }}>{formatter.format(data.total_payment || 0)}</span> */}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={10}>
                      <span style={{ fontWeight: "bold" }}>{formatter.format(data.total_due || 0)}</span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={11} />
                  </Table.Summary.Row>
                </Table.Summary>
              )}
            />
          )}
        </Spin>

        {/* Hidden Print Template */}
        <div style={{ display: "none" }}>
          <div ref={componentRef} style={{ padding: "20px" }}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h2>{businessprofile.business_name}</h2>
              <p dangerouslySetInnerHTML={{ __html: businessprofile.address }}></p>
              <h3>Dispatch Report</h3>
              {start.current && end.current && (
                <p>From: {start.current} To: {end.current}</p>
              )}
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Invoice No</th>
                  <th>Dispatch Date</th>
                  <th>Location</th>
                  <th>Courier</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Account No</th>
                  <th>Transaction No</th>
                  <th>Payment</th>
                  <th>Due</th>
                </tr>
              </thead>
              <tbody>
                {data.results.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.invoice_number}</td>
                    <td>{item.dispatch_date}</td>
                    <td>{item.location_name}</td>
                    <td>{item.delivery_type_name}</td>
                    <td>{item.contact_name}</td>
                    <td>{item.contact_phone}</td>
                    <td>{item.Account_no || item.account_no || "N/A"}</td>
                    <td>{item.Transection_no || item.transaction_no || "N/A"}</td>
                    <td align="right">{formatter.format(item.payment)}</td>
                    <td align="right">{formatter.format(item.due)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="9" style={{ textAlign: "right" }}>Total</th>
                  <th style={{ textAlign: "right" }}>{formatter.format(data.total_payment || 0)}</th>
                  <th style={{ textAlign: "right" }}>{formatter.format(data.total_due || 0)}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({ 
  Auth: state.auth,
  businessprofile: state.settings.businessprofile 
});

export default connect(mapStateToProps, { getDispatchReport, getAllLocationPlain, getdeliverytype })(DispatchReport);
